module.exports = __webpack_public_path__ + "static/media/colorContrast.413a10a8.PNG";